import { render, staticRenderFns } from "./AnchorNav.vue?vue&type=template&id=daaf5da2&scoped=true"
import script from "./AnchorNav.vue?vue&type=script&lang=js"
export * from "./AnchorNav.vue?vue&type=script&lang=js"
import style0 from "./AnchorNav.vue?vue&type=style&index=0&id=daaf5da2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daaf5da2",
  null
  
)

export default component.exports